import React, { useEffect, useState, useRef } from 'react';
import { FlagIcon } from 'lucide-react';
export function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="bg-white text-black pt-12 pb-16 sm:pt-16 sm:pb-20 md:pt-20 md:pb-28 px-6 sm:px-12 md:px-16 lg:px-24" id="about" data-id="element-1874">
      <div className="container mx-auto" data-id="element-1875">
        <h2 className="text-3xl sm:text-4xl md:text-5xl mb-8 sm:mb-12 md:mb-20 text-black text-center tracking-wide leading-tight" style={{
        fontFamily: "'Gefika', sans-serif",
        fontWeight: 400,
        letterSpacing: '0.02em',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
      }} data-id="element-1876">
          About Me
        </h2>
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 max-w-6xl mx-auto" data-id="element-1877">
          {/* Left column with image */}
          <div className="md:w-2/5 relative" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s'
        }} data-id="element-1878">
            <div className="relative overflow-hidden rounded-sm" data-id="element-1879">
              <img src="https://cdn.magicpatterns.com/uploads/9rtAe3QwDVg5E3pEqbuaLK/IMG_0117.jpg" alt="Mateo Cohen portrait" className="w-full h-[280px] sm:h-[350px] md:h-[350px] md:max-h-[350px] object-cover grayscale" style={{
              objectPosition: 'center 20%',
              filter: 'grayscale(100%) contrast(1.1)'
            }} data-id="element-1880" />
            </div>
          </div>
          {/* Right column with text */}
          <div className="md:w-3/5" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.8s ease-out 0.4s, transform 0.8s ease-out 0.4s'
        }} data-id="element-1881">
            <p className="text-base sm:text-lg leading-relaxed mb-6 sm:mb-8 font-normal text-[#666666] font-switzer" data-id="element-1882">
              I currently work at AArete, a Chicago-based consulting firm, where
              I lead the AI SaaS product for a data-heavy healthcare AI project.
              I also lead the conversational design of our agent, helping shape
              how users interact with complex healthcare data. I will be rolling
              off this project at the end of January 2026 and am actively
              exploring new opportunities.
            </p>
            <p className="text-base sm:text-lg text-[#666666] leading-relaxed font-normal font-switzer mb-6 sm:mb-8" data-id="element-1883">
              Beyond work, I'm a family man with two boys and an amazing
              partner. We call Ohio home, where weekends often mean watching
              football together. Our household is creative at its core. We're
              home to music producers and songwriters, always exploring new
              sounds and ideas. When I can, I volunteer coaching high school
              soccer, giving back to the community that's shaped us.
            </p>
            <div className="flex items-center gap-2 text-base sm:text-lg text-[#666666] font-switzer" data-id="element-1884">
              <span className="text-2xl" role="img" aria-label="United States flag" data-id="element-1885">
                🇺🇸
              </span>
              <span className="font-normal" data-id="element-1886">Located in Ohio</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}